<template>
    <div
        class="hero"
        v-if="section"
        :class="{ first, illustrated: section.media !== null }"
    >
        <h1 class="title">
            <strong v-if="section.title" v-html="section.title" />
            <span v-if="section.subtitle" v-html="section.subtitle" />
        </h1>
        <hero-link :section="section" @click="$emit('scroll')" />
        <transition name="grow" appear>
            <div class="media" v-if="section.media">
                <img :src="getUrl(section.media.id, 1600)" />
            </div>
        </transition>
    </div>
</template>

<script>
import HeroLink from "@/components/HeroLink";
import getters from "@/mixins/getters.mixin";
import { scroll, clearScroll } from "@/services/scroll.animation";

export default {
    mixins: [getters],
    components: { HeroLink },
    props: {
        sectionName: {
            type: String,
            required: true,
        },
        first: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        id() {
            return `hero-section-${this.sectionName}`;
        },
        section() {
            return this.getSection(this.sectionName);
        },
    },
    mounted() {
        scroll(this.id, this.$el, this.section.colors);
    },
    beforeDestroy() {
        clearScroll(this.id);
    },
};
</script>

<style scoped lang="sass">
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/motion
@import ~styles/typography

.hero
    position: relative
    display: flex
    align-items: center
    max-width: 100vw
    min-height: 100vh
    box-sizing: border-box
    padding: 0 12.5%
    color: white

    +media('<small')
        overflow: hidden
        text-align: center

    &.illustrated
        .title
            +media('<small')
                margin-top: 60vw

.title
    position: relative
    z-index: 1

    +media('<small')
        width: 100%
    strong
        display: block

.media
    position: absolute
    width: 37.25vw
    height: 37.25vw
    left: 37.25vw
    top: calc(50% - 18.625vw)
    border-radius: 100%
    overflow: hidden

    &:after
        border-radius: 100%
        position: absolute
        content: ''
        inset: 0
        box-shadow: inset 0 0 10px rgba(0,0,0,0.25)
        background-image:  linear-gradient(90deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0) 100%)
    img
        width: 100%
        height: 100%
        object-fit: cover
        object-position: center

+media('<small')
    .hero
        overflow: hidden

    .media
        width: min(400px, 67vw)
        height: min(400px, 67vw)
        left: calc(50% - min(200px, 33.5vw))
        top: calc(50% - min(300px, 60vw))

    .title
        font-size: 28px
        margin-top: -10vw

.grow-enter-active
    transition: all 450ms ease-in-out

.grow-enter
    opacity: 0
    transform: scale(0.98)

.grow-enter-to
    opacity: 1
    transform: scale(1)
</style>
